import { oc } from '@orpc/contract';
import { listUsersInputSchema, listUsersOutputSchema } from '../schemas/users.schemas.js';
export const listUsersContract = oc
    .route({
    method: 'GET',
    path: '/users',
    tags: ['Users'],
    summary: 'List every account with its role, status and pillar grants (ADMIN)',
})
    .input(listUsersInputSchema)
    .output(listUsersOutputSchema);
//# sourceMappingURL=list-users.contract.js.map